import http from '../../../utils/fetch';

export default {
    selectChannelIndex(v) {
        return http({
            url: '/api/swyl/v1/demo/bscXsptTargetInt/selectChannelIndex',
            method: 'get',
            params: v
        });
    },

    selectLianqunIndex(v) {
        return http({
            url: '/api/swyl/v1/demo/bscXsptTargetInt/selectLianqunIndex',
            method: 'get',
            params: v
        });
    },

}